/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LoginRequestApproveRequestDto } from '../models/login-request-approve-request-dto';
import { LoginRequestCreateRequestDto } from '../models/login-request-create-request-dto';
import { LoginRequestCreateResponseDto } from '../models/login-request-create-response-dto';
import { LoginRequestRejectRequestDto } from '../models/login-request-reject-request-dto';

@Injectable({
  providedIn: 'root',
})
export class LoginRequestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loginRequestControllerFindActive
   */
  static readonly LoginRequestControllerFindActivePath = '/login-requests/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActive$Response(params?: {
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, LoginRequestControllerService.LoginRequestControllerFindActivePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActive(params?: {
  }): Observable<any> {

    return this.findActive$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation loginRequestControllerApprove
   */
  static readonly LoginRequestControllerApprovePath = '/login-requests/approve/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approve()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approve$Response(params: {
    id: string;
    body?: LoginRequestApproveRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, LoginRequestControllerService.LoginRequestControllerApprovePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approve$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approve(params: {
    id: string;
    body?: LoginRequestApproveRequestDto
  }): Observable<any> {

    return this.approve$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation loginRequestControllerReject
   */
  static readonly LoginRequestControllerRejectPath = '/login-requests/reject/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reject$Response(params: {
    id: string;
    body?: LoginRequestRejectRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, LoginRequestControllerService.LoginRequestControllerRejectPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reject(params: {
    id: string;
    body?: LoginRequestRejectRequestDto
  }): Observable<any> {

    return this.reject$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation loginRequestControllerCreate
   */
  static readonly LoginRequestControllerCreatePath = '/login-requests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: LoginRequestCreateRequestDto
  }): Observable<StrictHttpResponse<LoginRequestCreateResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, LoginRequestControllerService.LoginRequestControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoginRequestCreateResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: LoginRequestCreateRequestDto
  }): Observable<LoginRequestCreateResponseDto> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<LoginRequestCreateResponseDto>) => r.body as LoginRequestCreateResponseDto)
    );
  }

}
